<div class="ws-accent-card ws-accent-card--teal">
    <div class="ws-accent-card__head">
        <div class="cp-title-row">
            <h3 class="ws-accent-card__title">Chapter progress</h3>
            <button *ngIf="careProgramId" class="btn-full-prog" type="button" (click)="openFullProgramme()">
                Show full programme <i class="bi bi-chevron-right btn-full-prog__icon"></i>
            </button>
        </div>
    </div>
    <div class="ws-accent-card__body">

        @for (chapter of weeklySummary?.chapters; track chapter) {
            <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center gap-1 flex-grow-1 me-3">
                    <div class="mb-1" style="font-size: 0.8125rem;">{{ chapter.displayTitlePortal }}</div>
                    <button
                        *ngIf="chapter.id && careProgramId"
                        class="cp-info-btn"
                        type="button"
                        (click)="openInfo(chapter)"
                        aria-label="Chapter info">
                        <i class="bi bi-info-circle"></i>
                    </button>
                </div>
                <div *ngIf="chapter.progressValue >= 1">
                    <i class="bi bi-check2 fs-4" style="color: var(--teal, #17627A);"></i>
                </div>
            </div>
            <div class="progress rounded-pill mb-4" style="height: 10px;">
                <div class="progress-bar rounded-pill" style="width: {{ chapter.progressValue * 100 }}%; background: var(--teal, #17627A);"></div>
            </div>
        }

        <div class="d-flex align-items-start justify-content-between" *ngIf="disabled">
            <div class="flex-grow-1 me-3">
                <div class="mb-1">---</div>
            </div>
            <div>
                <i class="bi bi-app text-light fs-4"></i>
            </div>
        </div>
        <div class="progress rounded-pill mb-4" style="height: 10px;" *ngIf="disabled">
            <div class="progress-bar rounded-pill" style="width: 0%; background: var(--teal, #17627A);"></div>
        </div>

    </div>
</div>
